// Static OEM list for vehicle manufacturers in India
export const OEM_LIST = [
    // Indian Brands
    { id: "TATA", name: "Tata Motors" },
    { id: "MAHINDRA", name: "Mahindra & Mahindra" },
    { id: "FORCE", name: "Force Motors" },

    // Popular Mass Market Brands
    { id: "MARUTI_SUZUKI", name: "Maruti Suzuki" },
    { id: "HYUNDAI", name: "Hyundai" },
    { id: "KIA", name: "Kia" },
    { id: "HONDA", name: "Honda" },
    { id: "TOYOTA", name: "Toyota" },
    { id: "RENAULT", name: "Renault" },
    { id: "NISSAN", name: "Nissan" },
    { id: "VOLKSWAGEN", name: "Volkswagen" },
    { id: "SKODA", name: "Skoda" },
    { id: "MG", name: "MG Motor" },
    { id: "CITROEN", name: "Citroen" },
    { id: "JEEP", name: "Jeep" },
    { id: "FORD", name: "Ford" },
    { id: "ISUZU", name: "Isuzu" },
    { id: "FIAT", name: "Fiat" },
    { id: "DATSUN", name: "Datsun" },

    // Luxury Brands
    { id: "BMW", name: "BMW" },
    { id: "MERCEDES_BENZ", name: "Mercedes-Benz" },
    { id: "AUDI", name: "Audi" },
    { id: "VOLVO", name: "Volvo" },
    { id: "LEXUS", name: "Lexus" },
    { id: "JAGUAR", name: "Jaguar" },
    { id: "LAND_ROVER", name: "Land Rover" },
    { id: "PORSCHE", name: "Porsche" },
    { id: "MINI", name: "Mini" },

    // Others
    { id: "OTHER", name: "Other" }
];

// List of brands that have images in public/media/car/
const BRAND_IMAGES_AVAILABLE = [
    'AUDI', 'BMW', 'CITROEN', 'FORCE', 'HONDA', 'HYUNDAI', 'ISUZU', 'JAGUAR', 
    'JEEP', 'KIA', 'LAND_ROVER', 'LEXUS', 'MAHINDRA', 'MARUTI_SUZUKI', 
    'MERCEDES_BENZ', 'MG', 'MINI', 'NISSAN', 'PORSCHE', 'RENAULT', 'SKODA', 
    'TATA', 'TOYOTA', 'VOLKSWAGEN', 'VOLVO', 'FORD'
];

const DEFAULT_IMAGE = 'default.png';

/**
 * Helper to get the brand image filename based on brand name
 * @param {string} brandName
 * @returns {string} filename (e.g., 'TATA.png')
 */
export function getBrandImage(brandName) {
    if (!brandName || typeof brandName !== 'string' || brandName.trim() === '') {
        return DEFAULT_IMAGE;
    }

    const normalizedInput = brandName.toLowerCase().replace(/[^a-z0-9]/g, '');

    // Iterate through OEM list to find a match
    for (const oem of OEM_LIST) {
        if (oem.id === 'OTHER') continue;

        const idNormalized = oem.id.toLowerCase();
        const nameNormalized = oem.name.toLowerCase().replace(/[^a-z0-9]/g, '');

        let matchFound = false;

        // 1. Exact ID match (e.g. "TATA")
        if (idNormalized === normalizedInput) {
            matchFound = true;
        }
        // 2. Name contains input (e.g. input "Maruti" matches name "Maruti Suzuki")
        // OR Input contains Name (e.g. input "Tata Motors Ltd" matches name "Tata Motors")
        else if (nameNormalized.includes(normalizedInput) || normalizedInput.includes(nameNormalized)) {
            matchFound = true;
        }
        // 3. Input contains ID (e.g. "TATA Cars")
        else if (normalizedInput.includes(idNormalized)) {
            matchFound = true;
        }

        if (matchFound) {
            // Check if we actually have the image for this brand
            if (BRAND_IMAGES_AVAILABLE.includes(oem.id)) {
                return `${oem.id}.png`;
            } else {
                return DEFAULT_IMAGE;
            }
        }
    }

    return DEFAULT_IMAGE;
}
